import React from 'react';
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import cn from 'classnames';
import RequestTile from 'components/RequestsTile';
import RequestListView from 'components/RequestListView';
import Nocontentfound from '../Tutorial/Nocontentfound';

import styles from '../DashboardView.scss';

const RequestView = (props) => {
  const { gridView, requests, subscribed, requestViewedCount } = props;
  let myRequests = requests || [];
  const newestContacted = [];
    for (let i = 0; i < myRequests.size; i++) { // eslint-disable-line
      const temp = myRequests.get(i);
      if (temp.get('conversation').size > 1) {
        newestContacted.push(temp);
        myRequests = myRequests.delete(i);
      }
    }

  const renderGridView = renderIf(gridView);
  const renderListView = renderIf(!gridView);
  const renderNoContentFound = renderIf(requests.size === 0 && subscribed);
  const renderCounterText = renderIf(requestViewedCount);
  return (
    <div className={cn('col s12', styles.alignCenter)} >
      {renderCounterText(
        <p className={styles.requestViewedCount}>
          {requestViewedCount} {requestViewedCount === 1 ? 'Coach' : 'Coaches' } viewed your profile.
        </p>)}
      {renderGridView(
        <div>
          {newestContacted.map(item => <RequestTile request={item} />)}
          {myRequests.map(item => <RequestTile request={item} />)}
        </div>,
      )}
      {renderListView(
        <div>
          {newestContacted.map(item => <RequestListView request={item} />)}
          {myRequests.map(item => <RequestListView request={item} />)}
        </div>,
      )}
      {renderNoContentFound(<Nocontentfound text="" />)}
    </div>
  );
};

RequestView.propTypes = {
  gridView: PropTypes.bool.isRequired,
  requests: PropTypes.shape.isRequired,
  subscribed: PropTypes.bool.isRequired,
  requestViewedCount: PropTypes.number.isRequired,
};

export default RequestView;




// WEBPACK FOOTER //
// ./src/components/DashboardView/requests/requests.js